import React from 'react';
import PropTypes from 'prop-types';

const PlayerListSeparator = ({title, extraClasses, rightIcon, onRightIconClick}) => {
    let classNames = 'players__separator ';
    if (extraClasses) {
        classNames += extraClasses;
    }

    let renderedRightIcon = null;
    const rightIconClassName = `right-icon ${rightIcon}`;

    if (rightIcon) {
        renderedRightIcon = <i className={rightIconClassName} onClick={onRightIconClick} />;
    }

    return (
        <div className={classNames}>
            <div className="container">
                {title}
                {renderedRightIcon}
            </div>
        </div>
    );
};

PlayerListSeparator.propTypes = {
    title: PropTypes.string.isRequired,
    extraClasses: PropTypes.string,
    rightIcon: PropTypes.string,
    onRightIconClick: PropTypes.func,
};

export default PlayerListSeparator;



// WEBPACK FOOTER //
// ./src/apps/create_game/components/Player/PlayersListSeparator.js